import React from "react";
import { motion } from "framer-motion";
import { ChartMotif } from "./ChartMotif";
import { EASE } from "../../lib/motion";

export const KpiCard = ({ className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 40, scale: 0.96 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1, ease: EASE }}
    className={`w-full max-w-md bg-[#FAF8F5] border border-[rgba(28,28,30,0.12)] rounded-[3px] p-6 md:p-8 shadow-[0_30px_80px_-40px_rgba(28,28,30,0.5)] ${className}`}
    data-testid="revenue-kpi-card"
  >
    <div className="flex items-center justify-between mb-1">
      <span className="font-body text-[10px] uppercase tracking-[0.22em] text-[#3E4A5C]">
        Weekly revenue
      </span>
      <span className="font-body text-xs font-semibold text-[#B39B77]">+18.4%</span>
    </div>
    <p className="font-display text-3xl text-[#1C1C1E] mb-4">&#8377; 4.82L</p>
    <ChartMotif className="w-full h-auto" />
    <div className="mt-6 grid grid-cols-3 gap-3 border-t border-[rgba(28,28,30,0.1)] pt-5">
      {[
        { k: "Best day", v: "Saturday" },
        { k: "Top style", v: "Linen co-ord" },
        { k: "Restock", v: "3 SKUs" },
      ].map((s) => (
        <div key={s.k}>
          <p className="font-body text-[9px] uppercase tracking-[0.14em] text-[#3E4A5C]/70">{s.k}</p>
          <p className="font-body text-sm font-medium text-[#1C1C1E] mt-1">{s.v}</p>
        </div>
      ))}
    </div>
  </motion.div>
);
